var map = {
	"./AllBoardsIcon.svg": 55883,
	"./Archeive.svg": 9983,
	"./AssignedTasksIcon.svg": 1619,
	"./Avatar.svg": 24813,
	"./Calendar.svg": 99888,
	"./Chart_100.svg": 71950,
	"./Check_icon.svg": 10190,
	"./CompletedTasksIcon.svg": 78814,
	"./Filter.svg": 50760,
	"./Graph.svg": 10994,
	"./Norton_Icon.svg": 16710,
	"./Payment_Apple.svg": 57161,
	"./Payment_mastercard.svg": 643,
	"./Payment_paypal.svg": 46478,
	"./Payment_stripe.svg": 40160,
	"./Payment_visa.svg": 58164,
	"./ScheduledTasksIcon.svg": 60320,
	"./Secure_icon.svg": 30207,
	"./Vector.svg": 68543,
	"./account.svg": 87819,
	"./activity-up.svg": 7045,
	"./adobe-premiere.svg": 90513,
	"./applicant.png": 20882,
	"./assess.png": 32888,
	"./bar-chart-icon.svg": 83512,
	"./bar-chart.svg": 68126,
	"./bar-graph.svg": 68946,
	"./boards.svg": 48701,
	"./build.svg": 97458,
	"./button-dots.svg": 21679,
	"./button-profile.svg": 68454,
	"./chart.svg": 33694,
	"./check-circle.svg": 68103,
	"./check-green.svg": 89096,
	"./chrome_reader_mode.svg": 77648,
	"./close-icon.svg": 52160,
	"./compensation.svg": 35592,
	"./completion.png": 56668,
	"./copy-icon.svg": 99733,
	"./delete.svg": 4179,
	"./department_icon.svg": 94500,
	"./description_icon.svg": 14488,
	"./dots-2.svg": 85671,
	"./edit.svg": 81230,
	"./email.svg": 44886,
	"./fingerprint.svg": 16826,
	"./gantt.svg": 14440,
	"./google-cloud.svg": 39027,
	"./green-circle.svg": 65136,
	"./group.svg": 42715,
	"./ic_telegram.svg": 35352,
	"./ic_whatsapp.svg": 57587,
	"./icon_Phone.svg": 93464,
	"./icon_bag.svg": 83982,
	"./icon_cam.svg": 42249,
	"./icon_category.svg": 18676,
	"./icon_clothes.svg": 84380,
	"./icon_conflict.svg": 93026,
	"./icon_dots.svg": 67184,
	"./icon_down_arrow.svg": 37330,
	"./icon_edit.svg": 55112,
	"./icon_eye.svg": 43923,
	"./icon_eye_closed.svg": 27738,
	"./icon_facebook.svg": 27984,
	"./icon_file.svg": 65126,
	"./icon_github.svg": 80369,
	"./icon_globe.svg": 61691,
	"./icon_hamburger.svg": 25929,
	"./icon_hospital_insurance.svg": 45171,
	"./icon_idea.svg": 31157,
	"./icon_linkedIn.svg": 69746,
	"./icon_location.svg": 1177,
	"./icon_lunch.svg": 54392,
	"./icon_moneybag.svg": 90170,
	"./icon_more.svg": 56927,
	"./icon_people.svg": 23597,
	"./icon_plus.svg": 95116,
	"./icon_share.svg": 5509,
	"./icon_trust.svg": 23858,
	"./icon_type.svg": 80116,
	"./icon_website.svg": 14979,
	"./imagedecor.svg": 39312,
	"./industry_icon.svg": 79136,
	"./invoice.svg": 97823,
	"./job_icon.svg": 31941,
	"./lion.svg": 22568,
	"./list-tasks.svg": 81911,
	"./local_phone.svg": 6858,
	"./lock-icon.svg": 37175,
	"./lock.svg": 77731,
	"./lock_icon.svg": 9565,
	"./mail.svg": 27367,
	"./minus.svg": 61446,
	"./name_icon.svg": 37537,
	"./notes.svg": 38873,
	"./plus.svg": 92846,
	"./profile_image.svg": 78475,
	"./profilepic.png": 53447,
	"./red-half-circle.svg": 74616,
	"./referral.svg": 23117,
	"./search-icon.svg": 30980,
	"./seniority_icon.svg": 33298,
	"./skills_icon.svg": 99940,
	"./slack.svg": 61666,
	"./successRate.png": 88239,
	"./user_icon.svg": 8997,
	"./web_icon.svg": 9536,
	"./white_fb_icon.svg": 96540,
	"./white_instagram_icon.svg": 99216,
	"./white_ln_icon.svg": 10298,
	"./widget-chart.svg": 50769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62704;